// removed by extract-text-webpack-plugin
module.exports = {"Buttons":"StatelessSwitcher__Buttons___1hTxM","Button":"StatelessSwitcher__Button___3IsuP","Text":"StatelessSwitcher__Text___1dFIz","Round":"StatelessSwitcher__Round___3mi6e","EnabledElement":"StatelessSwitcher__EnabledElement___1VxGm","ChessSwitcher":"StatelessSwitcher__ChessSwitcher___3OrjL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/StatelessSwitcher/StatelessSwitcher.scss
// module id = 1397
// module chunks = 0